export const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export type Validator = (value:any) => (boolean | string);

export const requiredValidator:Validator = function(value) {
	if (!value) {
		return false;
	}
	if (typeof(value) == "string") {
		if (value.match(/^\s*$/)) {
			return false;
		}
		return true;
	}
	if (typeof(value) == "number") {
		if (value == 0) {
			return false;
		}
		return true;
	}
	if (typeof(value) == "boolean") {
		if (!value) {
			return false;
		}
		return true;
	}
	if (typeof(value) == "object") {
		return true;
	}
	return false;
};

export const emailValidator:Validator = function(value:string):boolean {
	if (!value){
		return false;
	}
	return emailRegex.test(value);
};